export default __webpack_public_path__ + "static/media/profile_icon.f50fe0bf.png";